<template>
  <div class="control-group"
      :class="{
        'invalid': input_invalids && input_invalids[input_name],
        'disabled': input_disabled
      }"
      ref="ref_group">
    <div class="control" :class="{'required': input_required}">
      <label v-if="label_tooltip" :for="input_id" v-tooltip="label_tooltip">
        {{ Language.say(label_text) }}
      </label>
      <label v-else :for="input_id">
        {{ Language.say(label_text) }}
      </label>
      <input
        :id="input_id"
        :type="input_type"
        :placeholder="input_placeholder"
        :value="input_value"
        @input="onInputValue"
        @change="onChangeValue"
        :disabled="input_disabled"
        v-focus="input_focus">
      <p class="error" v-if="input_invalids && input_invalids[input_name]">
        {{ Language.say(error_text) }}
      </p>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';
  import Language                     from '@/js/Shared/Language/Language';

  const props = defineProps({
    input_id: {
      type: String,
      default: '',
    },
    input_name: {
      type: String,
      required: true,
    },
    input_required: {
      type: Boolean,
      default: false
    },
    input_invalids: {
      type: Object,
      default : {},
    },
    input_value: {
      type: String,
      default: ''
    },
    input_placeholder: {
      type: String,
      default: '',
    },
    input_focus: {
      type: Boolean,
      default: false,
    },
    input_type: {
      type: String,
      default: 'text'
    },
    input_disabled: {
      type: Boolean,
      default: false
    },
    label_text: {
      type: String,
      default: ''
    },
    label_tooltip:{
      type: String,
      default: ''
    },
    error_text: {
      type: String,
      default: 'global.forms.invalid.input'
    },
  });

  const emit = defineEmits(['change', 'update:input_value']);

  const onChangeValue = ($event) => {
    emit('change', $event.target.value);
  }

  const onInputValue = ($event) => {
    emit('update:input_value', $event.target.value)
  }
</script>
